// const normalizeSrc = src => {
//     return src.startsWith('/') ? src.slice(1) : src;
// };

export const cloudflareLoader = ({ src, width, quality = 85 }) => {
    if(process.env.NEXT_PUBLIC_WIGZO_ENV == 'dev'){
        return src;
    }

    // Ensure quality is at least 80 for better image quality
    const imageQuality = Math.max(quality || 85, 80);
    
    // Use specific formats instead of auto for better quality control
    const params = [
        `width=${width}`,
        `quality=${imageQuality}`,
        `format=webp` // Use WebP for better quality/size ratio
    ];
    
    const paramsString = params.join(',');

    if( src.startsWith('/')){
        return `/cdn-cgi/image/${paramsString}/${src.slice(1)}`
    }

    const [subdomain, path] = src.split(".in/");
    return `${subdomain}.in/cdn-cgi/image/${paramsString}/${path}`;
};

